const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

export default styles
